import * as React from 'react';

import { MenuSelectIcons } from '../../menu-select-icons-button';
import { Input } from '../input';
import { Styled } from './styled';

export const IconInput = (props) => {
  const {
  iconListMap,
  selectedId,
  onChangeIcon,
  name,
  onChangeValue,
  type,
  value,
  placeholder,
  autoFocus,
  position,
  disabled,
} = props;
  const input = { disabled, onChange: onChangeValue, name, value };

  return (
    <Styled.Container>
      {iconListMap &&
        <Styled.MenuSelectIconsContainer>
          <MenuSelectIcons
            iconListMap={iconListMap}
            selectedId={selectedId}
            position={position}
            disabled={disabled}
            onIconClick={onChangeIcon}
          />
        </Styled.MenuSelectIconsContainer>
      }
      <Styled.InputContainer isIcon={iconListMap}>
        <Input
          input={input}
          text={name}
          type={type}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      </Styled.InputContainer>
    </Styled.Container>
  );
};
